/**
 * Email addresses, as the allowlist and the sign-in form see them.
 *
 * Both sides import these, so the form refuses exactly what the worker would.
 */

/** Addresses are compared lower-cased and trimmed everywhere: the allowlist, accounts, the mail ceilings. */
export const normaliseEmail = (value: unknown): string =>
  String(value ?? "")
    .trim()
    .toLowerCase();

/** RFC 5321's limit on a forward path. */
export const MAX_EMAIL_LENGTH = 254;

/**
 * Deliberately not RFC 5322 (carried over from utucat). That grammar accepts
 * things no mail server will; the useful question is "could somebody who meant
 * an address have typed this", and anything that clears it and is still wrong
 * bounces.
 */
const EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export function validEmail(value: unknown): boolean {
  const email = normaliseEmail(value);
  return email.length > 0 && email.length <= MAX_EMAIL_LENGTH && EMAIL.test(email);
}
